import { render, staticRenderFns } from "./RequestActivityLog.vue?vue&type=template&id=55e3df82&scoped=true"
import script from "./RequestActivityLog.vue?vue&type=script&lang=js"
export * from "./RequestActivityLog.vue?vue&type=script&lang=js"
import style0 from "./RequestActivityLog.vue?vue&type=style&index=0&id=55e3df82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55e3df82",
  null
  
)

export default component.exports